import * as actionTypes from "./actionTypes";

const initialState = {
  pendingRequests: "",
  pendingPayments: "",
  totalPartnersData: null,
  totalCustomersData: "",
  totalCompletedTripsData: "",
  totalCancelledTripsData: "",
  totalBookingsData: null,
  totalRevenueData: "",
  partnerPerformanceData: null,
  regionalInsightsData: null,
  modelPerformanceData: null,
  pendingRequestsLastWeek: "",
  rentalPartnerData: [],
  reTotalBookingsData: [],
  reTotalRevenueData: [],
  reMostBookedRidesData: [],
  reInventoryStatusData: [],
  reInventoryBookingData: [],
  reInventoryBookingLoading: false,
  pendingLoading: false,
  pendingPaymentLoading: false,
  totalPartnerLoading: false,
  totalCustomerLoading: false,
  completedTripsLoading: false,
  cancelledTripsLoading: false,
  totalBookingsLoading: false,
  totalRevenueLoading: false,
  modelPerformanceLoading: false,
  partnerPerformanceLoading: false,
  regionalInsightsLoading: false,
  pendingRequestsLastWeekLoading: false,
  rentalPartnerLoading: false,
  reTotalBookingsLoading: false,
  reTotalRevenueLoading: false,
  reMostBookedRidesLoading: false,
  reInventoryStatusLoading: false,
};

const TourDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PENDING_REQUEST_DATA:
      return {
        ...state,
        pendingRequests: "",
        pendingLoading: true,
      };
    case actionTypes.GET_PENDING_REQUEST_DATA_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        pendingRequests: action.payload,
        pendingLoading: false,
      };
    case actionTypes.GET_PENDING_REQUEST_DATA_FAILURE:
      return {
        ...state,
        pendingRequests: "",
        pendingLoading: false,
      };

    case actionTypes.GET_PENDING_PAYMENT_DATA:
      return {
        ...state,
        pendingPayments: "",
        pendingPaymentLoading: true,
      };
    case actionTypes.GET_PENDING_PAYMENT_DATA_SUCCESS:
      return {
        ...state,
        pendingPayments: action.payload,
        pendingPaymentLoading: false,
      };
    case actionTypes.GET_PENDING_PAYMENT_DATA_FAILURE:
      return {
        ...state,
        pendingPayments: "",
        pendingPaymentLoading: false,
      };
    case actionTypes.GET_TOTAL_PARTNERS_DATA_TOURS:
      return {
        ...state,
        totalPartnersData: null,
        totalPartnerLoading: true,
      };
    case actionTypes.GET_TOTAL_PARTNERS_DATA_TOURS_SUCCESS:
      return {
        ...state,
        totalPartnersData: action.payload,
        totalPartnerLoading: false,
      };
    case actionTypes.GET_TOTAL_PARTNERS_DATA_TOURS_FAILURE:
      return {
        ...state,
        totalPartnersData: null,
        totalPartnerLoading: false,
      };

    case actionTypes.GET_TOTAL_CUSTOMERS_DATA:
      return {
        ...state,
        totalCustomersData: "",
        totalCustomerLoading: true,
      };
    case actionTypes.GET_TOTAL_CUSTOMERS_DATA_SUCCESS:
      return {
        ...state,
        totalCustomersData: action.payload,
        totalCustomerLoading: false,
      };
    case actionTypes.GET_TOTAL_CUSTOMERS_DATA_FAILURE:
      return {
        ...state,
        totalCustomersData: "",
        totalCustomerLoading: false,
      };

    case actionTypes.GET_COMPLETED_TRIPS_DATA:
      return {
        ...state,
        totalCompletedTripsData: "",
        completedTripsLoading: true,
      };
    case actionTypes.GET_COMPLETED_TRIPS_DATA_SUCCESS:
      return {
        ...state,
        totalCompletedTripsData: action.payload,
        completedTripsLoading: false,
      };
    case actionTypes.GET_COMPLETED_TRIPS_DATA_FAILURE:
      return {
        ...state,
        totalCompletedTripsData: "",
        completedTripsLoading: false,
      };

    case actionTypes.GET_CANCELLED_TRIPS_DATA:
      return {
        ...state,
        totalCancelledTripsData: "",
        cancelledTripsLoading: true,
      };
    case actionTypes.GET_CANCELLED_TRIPS_DATA_SUCCESS:
      return {
        ...state,
        totalCancelledTripsData: action.payload,
        cancelledTripsLoading: false,
      };
    case actionTypes.GET_CANCELLED_TRIPS_DATA_FAILURE:
      return {
        ...state,
        totalCancelledTripsData: "",
        cancelledTripsLoading: false,
      };

    case actionTypes.GET_TOTAL_BOOKINGS_DATA:
      return {
        ...state,
        totalBookingsData: null,
        totalBookingsLoading: true,
      };
    case actionTypes.GET_TOTAL_BOOKINGS_DATA_SUCCESS:
      return {
        ...state,
        totalBookingsData: action.payload,
        totalBookingsLoading: false,
      };
    case actionTypes.GET_TOTAL_BOOKINGS_DATA_FAILURE:
      return {
        ...state,
        totalBookingsData: null,
        totalBookingsLoading: false,
      };

    case actionTypes.GET_TOTAL_REVENUE_DATA:
      return {
        ...state,
        totalRevenueData: "",
        totalRevenueLoading: true,
      };
    case actionTypes.GET_TOTAL_REVENUE_DATA_SUCCESS:
      return {
        ...state,
        totalRevenueData: action.payload,
        totalRevenueLoading: false,
      };
    case actionTypes.GET_TOTAL_REVENUE_DATA_FAILURE:
      return {
        ...state,
        totalRevenueData: "",
        totalRevenueLoading: false,
      };

    case actionTypes.GET_PARTNER_PERFORMANCE_DATA:
      return {
        ...state,
        partnerPerformanceData: null,
        partnerPerformanceLoading: true,
      };
    case actionTypes.GET_PARTNER_PERFORMANCE_DATA_SUCCESS:
      return {
        ...state,
        partnerPerformanceData: action.payload,
        partnerPerformanceLoading: false,
      };
    case actionTypes.GET_PARTNER_PERFORMANCE_DATA_FAILURE:
      return {
        ...state,
        partnerPerformanceData: null,
        partnerPerformanceLoading: false,
      };

    case actionTypes.GET_REGIONAL_INSIGHTS_DATA:
      return {
        ...state,
        regionalInsightsData: null,
        regionalInsightsLoading: true,
      };
    case actionTypes.GET_REGIONAL_INSIGHTS_DATA_SUCCESS:
      return {
        ...state,
        regionalInsightsData: action.payload,
        regionalInsightsLoading: false,
      };
    case actionTypes.GET_REGIONAL_INSIGHTS_DATA_FAILURE:
      return {
        ...state,
        regionalInsightsData: null,
        regionalInsightsLoading: false,
      };

    case actionTypes.GET_MODEL_PERFORMANCE_DATA:
      return {
        ...state,
        modelPerformanceData: null,
        modelPerformanceLoading: true,
      };
    case actionTypes.GET_MODEL_PERFORMANCE_DATA_SUCCESS:
      return {
        ...state,
        modelPerformanceData: action.payload,
        modelPerformanceLoading: false,
      };
    case actionTypes.GET_MODEL_PERFORMANCE_DATA_FAILURE:
      return {
        ...state,
        modelPerformanceData: null,
        modelPerformanceLoading: false,
      };

    case actionTypes.GET_PENDING_REQUEST_LAST_WEEK_DATA:
      return {
        ...state,
        pendingRequestsLastWeek: "",
        pendingRequestsLastWeekLoading: true,
      };
    case actionTypes.GET_PENDING_REQUEST_LAST_WEEK_DATA_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        pendingRequestsLastWeek: action.payload,
        pendingRequestsLastWeekLoading: false,
      };
    case actionTypes.GET_PENDING_REQUEST_LAST_WEEK_DATA_FAILURE:
      return {
        ...state,
        pendingRequestsLastWeek: "",
        pendingRequestsLastWeekLoading: false,
      };
    case actionTypes.GET_RENTAL_PARTNER_DATA:
      return {
        ...state,
        rentalPartnerData: [],
        rentalPartnerLoading: true,
      };
    case actionTypes.GET_RENTAL_PARTNER_DATA_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        rentalPartnerData: action.payload,
        rentalPartnerLoading: false,
      };
    case actionTypes.GET_RENTAL_PARTNER_DATA_FAILURE:
      return {
        ...state,
        rentalPartnerData: [],
        rentalPartnerLoading: false,
      };
    case actionTypes.GET_RE_TOTAL_BOOKINGS_DATA:
      return {
        ...state,
        reTotalBookingsData: [],
        reTotalBookingsLoading: true,
      };
    case actionTypes.GET_RE_TOTAL_BOOKINGS_DATA_SUCCESS:
      return {
        ...state,
        reTotalBookingsData: action.payload,
        reTotalBookingsLoading: false,
      };
    case actionTypes.GET_RE_TOTAL_BOOKINGS_DATA_FAILURE:
      return {
        ...state,
        reTotalBookingsData: [],
        reTotalBookingsLoading: false,
      };
    case actionTypes.GET_RE_TOTAL_REVENUE_DATA:
      return {
        ...state,
        reTotalRevenueData: [],
        reTotalRevenueLoading: true,
      };
    case actionTypes.GET_RE_TOTAL_REVENUE_DATA_SUCCESS:
      return {
        ...state,
        reTotalRevenueData: action.payload,
        reTotalRevenueLoading: false,
      };
    case actionTypes.GET_RE_TOTAL_REVENUE_DATA_FAILURE:
      return {
        ...state,
        reTotalRevenueData: [],
        reTotalRevenueLoading: false,
      };
    case actionTypes.GET_RE_MOST_BOOKED_RIDES_DATA:
      return {
        ...state,
        reMostBookedRidesData: [],
        reMostBookedRidesLoading: true,
      };
    case actionTypes.GET_RE_MOST_BOOKED_RIDES_DATA_SUCCESS:
      return {
        ...state,
        reMostBookedRidesData: action.payload,
        reMostBookedRidesLoading: false,
      };
    case actionTypes.GET_RE_MOST_BOOKED_RIDES_DATA_FAILURE:
      return {
        ...state,
        reMostBookedRidesData: [],
        reMostBookedRidesLoading: false,
      };
    case actionTypes.GET_RE_INVENTORY_STATUS_DATA:
      return {
        ...state,
        reInventoryStatusData: [],
        reInventoryStatusLoading: true,
      };
    case actionTypes.GET_RE_INVENTORY_STATUS_DATA_SUCCESS:
      return {
        ...state,
        reInventoryStatusData: action.payload,
        reInventoryStatusLoading: false,
      };
    case actionTypes.GET_RE_INVENTORY_STATUS_DATA_FAILURE:
      return {
        ...state,
        reInventoryStatusData: [],
        reInventoryStatusLoading: false,
      };
    case actionTypes.GET_RE_INVENTORY_BOOKING_CALENDAR_DATA:
      return {
        ...state,
        reInventoryBookingData: [],
        reInventoryBookingLoading: true,
      };
    case actionTypes.GET_RE_INVENTORY_BOOKING_CALENDAR_DATA_SUCCESS:
      return {
        ...state,
        reInventoryBookingData: action.payload,
        reInventoryBookingLoading: false,
      };
    case actionTypes.GET_RE_INVENTORY_BOOKING_CALENDAR_DATA_FAILURE:
      return {
        ...state,
        reInventoryBookingData: [],
        reInventoryBookingLoading: false,
      };
    default:
      return state;
  }
};

export default TourDashboardReducer;
